import { cn } from "@/lib/utils";
import * as React from "react";

export interface EyebrowProps extends React.HTMLAttributes<HTMLSpanElement> {
  /** Draw the short hairline that precedes the label. */
  rule?: boolean;
  tone?: "ink" | "muted" | "olive" | "inverse";
}

/**
 * The small wide-tracked label that sits above a heading. Along with the
 * hairline rule it is the site's main structural signal — it is how a reader
 * knows a new section has started without a box being drawn around it.
 */
const Eyebrow = React.forwardRef<HTMLSpanElement, EyebrowProps>(
  ({ className, rule = true, tone = "muted", children, ...props }, ref) => (
    <span
      ref={ref}
      className={cn(
        "inline-flex items-center gap-4 font-heading text-eyebrow font-medium uppercase tracking-wide2",
        tone === "ink" && "text-kf-ink",
        tone === "muted" && "text-kf-muted",
        tone === "olive" && "text-kf-olive",
        tone === "inverse" && "text-kf-white/70",
        className
      )}
      {...props}
    >
      {rule ? <span aria-hidden className="h-px w-8 bg-current opacity-60" /> : null}
      {children}
    </span>
  )
);
Eyebrow.displayName = "Eyebrow";

export { Eyebrow };
